import React from 'react'
import {
  Wrapper,
  Container
} from '../../../styled-components/styled-components'
import { Typography, Card, Col } from 'antd'
import OrderForm from './InsuranceQuoteForm'

const { Title } = Typography

const OrderSectionInsuranceQuote = () => {
  return (
    <Wrapper className="nff-indigo" id="insurance-form-section">
      <Container style={{ padding: '0px' }}>
        <Title
          level={1}
          style={{ color: 'white', textAlign: 'center', fontSize: '40px' }}
        >
          Request Insurance Quote
        </Title>

        <Col
          xl={14}
          lg={14}
          md={24}
          sm={24}
          xs={24}
          style={{ margin: '0 auto' }}
        >
          <Card className="box-shadow round">
            <OrderForm />
          </Card>
        </Col>
      </Container>
    </Wrapper>
  )
}

export default OrderSectionInsuranceQuote
